<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              1. ข้อมูลหัวหน้าโครงการและคณะผู้เชี่ยวชาญ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
                theme="6"
                :disabled="teams.length >= 5"
                @onClick="addMoreTeam"
            >
              + เพิ่มข้อมูลคณะ
            </Button>
          </div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">ชื่อ - สกุล</div>
              <TextField
                theme="3"
                :value="form.s2_p1_name"
                @onChange="setFormField('s2_p1_name', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">ตำเเหน่ง</div>
              <AutoBox
                theme="3"
                :items="masterData.positions"
                item-text="name"
                item-value="name"
                :value="form.s2_p1_position"
                @onChange="setFormField('s2_p1_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">หน่วยงาน</div>
              <AutoBox
                theme="3"
                :items="masterData.institutes"
                item-text="name"
                item-value="name"
                :value="form.s2_p1_dep"
                @onChange="setFormField('s2_p1_dep', $event)"
              ></AutoBox>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">สังกัด</div>
              <TextField
                theme="3"
                :value="form.s2_p1_org"
                @onChange="setFormField('s2_p1_org', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">ที่อยู่</div>
              <TextField
                theme="3"
                :value="form.s2_p1_addr"
                @onChange="setFormField('s2_p1_addr', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
                  <TextField
                    placeholder="09XXXXXXXX"
                    theme="3"
                    input-type="number"
                    :value="form.s2_p1_phone"
                    @onChange="setFormField('s2_p1_phone', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">E-mail</div>
                  <TextField
                    theme="3"
                    :rules="emailRules"
                    :value="form.s2_p1_email"
                    @onChange="setFormField('s2_p1_email', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">ความเชี่ยวชาญ</div>
              <TextField
                theme="3"
                :value="form.s2_p1_expertise"
                @onChange="setFormField('s2_p1_expertise', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    สัดส่วนการทำงาน
                  </div>
                  <TextField
                      theme="3"
                      :value="form.s2_p1_resp"
                      @onChange="setFormField('s2_p1_resp', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    ชั่วโมงการทำงาน
                  </div>
                  <TextField
                      theme="3"
                      :value="form.s2_p1_resp_hrs"
                      @onChange="setFormField('s2_p1_resp_hrs', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <div class="px-5">
      <divcard
          v-for="(team, i) in teams"
          :key="i"
          class="mb-3"
      >
        <div class="black--text txt-m-head mb-3">1.{{ i + 1 }} ข้อมูลคณะ</div>
        <v-btn
            icon
            absolute
            top
            right
            style="z-index: 99"
            @click="delTeam(i)"
        >
          <Iconify
              class="font-18"
              style="color: #b1b1b1"
              icon="mdi:delete"
          />
        </v-btn>
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ชื่อ - สกุล</div>
            <TextField
                theme="3"
                :value="team.s2_p1_name"
                @onChange="setTeamField('s2_p1_name', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">ตำเเหน่ง</div>
            <AutoBox
                theme="3"
                :items="masterData.positions"
                item-text="name"
                item-value="name"
                :value="team.s2_p1_position"
                @onChange="setTeamField('s2_p1_position', i, $event)"
            ></AutoBox>
          </div>
        </div>

        <!-- Form 1 #line2 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">หน่วยงาน</div>
            <AutoBox
                theme="3"
                :items="masterData.institutes"
                item-text="name"
                item-value="name"
                :value="team.s2_p1_dep"
                @onChange="setTeamField('s2_p1_dep', i, $event)"
            ></AutoBox>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">สังกัด</div>
            <TextField
                theme="3"
                :value="team.s2_p1_org"
                @onChange="setTeamField('s2_p1_org', i, $event)"
            ></TextField>
          </div>
        </div>

        <!-- Form 1 #line3 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ที่อยู่</div>
            <TextField
                theme="3"
                :value="team.s2_p1_addr"
                @onChange="setTeamField('s2_p1_addr', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
                <TextField
                  placeholder="09XXXXXXXX"
                    theme="3"
                    input-type="number"
                    :value="team.s2_p1_phone"
                    @onChange="setTeamField('s2_p1_phone', i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">E-mail</div>
                <TextField
                    theme="3"
                    :rules="emailRules"
                    :value="team.s2_p1_email"
                    @onChange="setTeamField('s2_p1_email', i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>

        <!-- Form 1 #line4 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ความเชี่ยวชาญ</div>
            <TextField
                theme="3"
                :value="team.s2_p1_expertise"
                @onChange="setTeamField('s2_p1_expertise', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">
                  สัดส่วนการทำงาน
                </div>
                <TextField
                    theme="3"
                    :value="team.s2_p1_resp"
                    @onChange="setTeamField('s2_p1_resp', i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">
                  ชั่วโมงการทำงาน
                </div>
                <TextField
                    theme="3"
                    :value="team.s2_p1_resp_hrs"
                    @onChange="setTeamField('s2_p1_resp_hrs', i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>
      </divcard>
    </div>

    <divcard>
      <div class="card-part pt-0">
        <!-- Form 2 -->
        <div>
          <div class="txt-head black--text mb-3">
            2. ผู้รับผิดชอบโครงการ (Project Manager) (ภาคเอกชน)
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>
          <!-- Form 2 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ชื่อ - สกุล ผู้รับผิดชอบโครงการ
              </div>
              <TextField
                theme="3"
                :value="form.s2_p2_pm_name"
                @onChange="setFormField('s2_p2_pm_name', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">ตำเเหน่ง</div>
              <AutoBox
                theme="3"
                :items="masterData.positions"
                item-text="name"
                item-value="name"
                :value="form.s2_p2_pm_position"
                @onChange="setFormField('s2_p2_pm_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 2 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
                  <TextField
                    placeholder="09XXXXXXXX"
                    theme="3"
                    input-type="number"
                    :value="form.s2_p2_pm_phone"
                    @onChange="setFormField('s2_p2_pm_phone', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">E-mail</div>
                  <TextField
                    theme="3"
                    :rules="emailRules"
                    :value="form.s2_p2_pm_email"
                    @onChange="setFormField('s2_p2_pm_email', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>

          <!-- Form 2 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">
                ชื่อ - สกุล ผู้ประสานงานโครงการ
              </div>
              <TextField
                theme="3"
                :value="form.s2_p2_proj_coord_name"
                @onChange="setFormField('s2_p2_proj_coord_name', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">ตำเเหน่ง</div>
              <AutoBox
                theme="3"
                :items="masterData.positions"
                item-text="name"
                item-value="name"
                :value="form.s2_p2_proj_coord_position"
                @onChange="setFormField('s2_p2_proj_coord_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 2 #line4 -->
          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
                  <TextField
                    placeholder="09XXXXXXXX"
                    theme="3"
                    input-type="number"
                    :value="form.s2_p2_proj_coord_phone"
                    @onChange="setFormField('s2_p2_proj_coord_phone', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">E-mail</div>
                  <TextField
                    theme="3"
                    :rules="emailRules"
                    :value="form.s2_p2_proj_coord_email"
                    @onChange="setFormField('s2_p2_proj_coord_email', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <!-- Form 3 -->
        <div>
          <div class="txt-head black--text mb-3">
            3. ข้อมูลภาคเอกชนที่เข้าร่วมโครงการ (พื้นที่ดำเนินการ)
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>
          <!-- Form 2 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">ชื่อ - สกุล นิติบุคคล/กิจการ</div>
              <TextField
                theme="3"
                :value="form.s2_p3_prv_org_name"
                @onChange="setFormField('s2_p3_prv_org_name', $event)"
              ></TextField>
            </div>
            <div class="flex xs6">
              <div class="mb-1 black--text">ที่อยู่</div>
              <TextField
                theme="3"
                :value="form.s2_p3_prv_org_address"
                @onChange="setFormField('s2_p3_prv_org_address', $event)"
              ></TextField>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">จังหวัด</div>
              <AutoBox
                theme="3"
                :items="masterData.provinces"
                item-text="name"
                item-value="name"
                :value="form.s2_p3_addr_pid"
                @onChange="setFormField('s2_p3_addr_pid', $event)"
              ></AutoBox>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">เขต/อำเภอ</div>
              <AutoBox
                theme="3"
                :items="filteredDistricts"
                item-text="name"
                item-value="name"
                :value="form.s2_p3_addr_did"
                @onChange="setFormField('s2_p3_addr_did', $event)"
              ></AutoBox>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">แขวง/ตำบล</div>
              <AutoBox
                theme="3"
                :items="filteredSubdistricts"
                item-text="name"
                item-value="name"
                :value="form.s2_p3_addr_sdid"
                @onChange="setFormField('s2_p3_addr_sdid', $event)"
              ></AutoBox>
            </div>
          </div>
      
          <!-- Form 2 #line2 -->
          <div class="d-flex gap-16">
            <div class="flex xs6">
              <div class="flex-center gap-16">
                <div class="flex xs6">
                  <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
                  <TextField
                    placeholder="09XXXXXXXX"
                    theme="3"
                    input-type="number"
                    :value="form.s2_p3_prv_org_phone"
                    @onChange="setFormField('s2_p3_prv_org_phone', $event)"
                  ></TextField>
                </div>
                <div class="flex xs6">
                  <div class="mb-1 black--text">E-mail</div>
                  <TextField
                    theme="3"
                    :rules="emailRules"
                    :value="form.s2_p3_prv_org_email"
                    @onChange="setFormField('s2_p3_prv_org_email', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
          </div>

          <!-- Form 2 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                รูปแบบของธุรกิจ/ลักษณะกิจการ (แบบย่อ)
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextArea
                theme="3"
                :value="form.s2_p3_prv_org_type"
                @onChange="setFormField('s2_p3_prv_org_type', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 2 #line4 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ระบุแนวโน้มที่บริษัทจะเป็นผู้เช่าพื้นที่ในอุทยานวิทยาศาสตร์ภูมิภาคในอนาคต
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <TextArea
              theme="3"
              :value="form.s2_p3_prv_org_trend"
              @onChange="setFormField('s2_p3_prv_org_trend', $event)"
            ></TextArea>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 2 #line5 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-3 black--text">
              สัดส่วนการลงทุนของเอกชนในการร่วมโครงการ
              <span class="theme-color-seven txt-normal"
                >(ข้อมูลมาจากส่วนที่3)</span
              >
            </div>

            <div>
              <ul>
                <li>
                  <div class="d-flex justify-space-between" style="gap: 16px">
                    <div class="black--text pt-2">ภาคเอกชนสนับสนุนจำนวน</div>
                    <div class="d-flex justify-end" style="gap: 16px">
                      <TextField
                        readonly
                        style="max-width: 200px"
                        theme="3"
                        :value="formatNumber(private_sum, 2)"
                      ></TextField>
                      <div class="black--text pt-2">บาท</div>
                      <div
                        class="black--text pt-2"
                        style="min-width: 80px; max-width: 80px"
                      >
                        โดยแบ่งเป็น
                      </div>
                      <div style="min-width: 200px; max-width: 200px"></div>
                    </div>
                  </div>

                  <ul style="list-style: none">
                    <li>
                      <div
                        class="d-flex justify-space-between"
                        style="gap: 16px"
                      >
                        <div class="pt-2">ส่วนที่เป็นตัวเงิน(In-cash)จำนวน</div>
                        <div class="d-flex justify-end" style="gap: 16px">
                          <TextField
                            readonly
                            style="max-width: 200px"
                            theme="3"
                            :value="formatNumber(incash_sum, 2)"
                          ></TextField>
                          <div class="pt-2">บาท</div>
                          <div
                            class="pt-2"
                            style="min-width: 80px; max-width: 80px"
                          >
                            คิดเป็นร้อยละ
                          </div>
                          <TextField
                            readonly
                            style="max-width: 200px"
                            theme="3"
                            :value="incash_percent"
                          ></TextField>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        class="d-flex justify-space-between"
                        style="gap: 16px"
                      >
                        <div class="pt-2">
                          ส่วนที่เป็นสิ่งของสนับสนุน(In-Kind)จำนวน
                        </div>
                        <div class="d-flex justify-end" style="gap: 16px">
                          <TextField
                            readonly
                            style="max-width: 200px"
                            theme="3"
                            :value="formatNumber(inkind_sum, 2)"
                          ></TextField>
                          <div class="pt-2">บาท</div>
                          <div
                            class="pt-2"
                            style="min-width: 80px; max-width: 80px"
                          >
                            คิดเป็นร้อยละ
                          </div>
                          <TextField
                            readonly
                            style="max-width: 200px"
                            theme="3"
                            :value="inkind_percent"
                          ></TextField>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li>
                  <div class="d-flex justify-space-between" style="gap: 16px">
                    <div class="black--text pt-2">
                      อุทยานวิทยาศาสตร์ภูมิภาค สนับสนุนจำนวน
                    </div>
                    <div class="d-flex justify-end" style="gap: 16px">
                      <TextField
                        readonly
                        style="max-width: 200px"
                        theme="3"
                        :value="formatNumber(scipark_sum, 2)"
                      ></TextField>
                      <div class="black--text pt-2">บาท</div>
                      <div
                        class="black--text pt-2"
                        style="min-width: 80px; max-width: 80px"
                      >
                        คิดเป็นร้อยละ
                      </div>
                      <TextField
                        readonly
                        style="max-width: 200px"
                        theme="3"
                        :value="scipark_percent"
                      ></TextField>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            4.
            กิจการของภาคเอกชนที่เข้าร่วมโครงการมีความเกี่ยวข้องในกลุ่มอุตสาหกรรม
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <AutoBox
                theme="3"
                :items="industryBusinesses"
                multiple
                chips
                deletable-chips
                :value="form.s2_p4_prv_org_involved"
                @onChange="setFormField('s2_p4_prv_org_involved', $event)"
              ></AutoBox>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                theme="3"
                :value="form.s2_p4_prv_org_other"
                @onChange="setFormField('s2_p4_prv_org_other', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">5. หลักการและเหตุผล</span>
            <span class="txt-normal" style="text-indent: 16px">
              (ระบุที่มาและความสำคัญของการดำเนินโครงการแสดงรายละเอียดข้อมูลของปัญหาที่ผู้ประกอบการต้องการพัฒนา
              และปรับปรุงประสิทธิภาพ
              และผลลัพธ์ที่คาดว่าจะได้รับจากการนําเทคโนโลยี องค์ความรู้
              และความช่วยเหลือของคณะผู้เชี่ยวชาญเข้าไปแก้ไขปัญหาและพัฒนากิจการ
              เพิ่มประสิทธิภาพของกิจการของผู้ประกอบการ ชี้แจง รายละเอียดโดยย่อ)
            </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
            >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
              theme="3"
              :value="form.s2_p11_principle"
              @onChange="setFormField('s2_p11_principle', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head"
            >{{ isFinal ? "4." : "6." }} วัตถุประสงค์</span
            >
            <span class="txt-normal" style="text-indent: 16px">
              (ระบุข้อมูลที่ใช้วัดผลความสำเร็จเมื่อเสร็จโครงการ
              แสดงทั้งในรูปแบบของเชิงปริมาณและคุณภาพให้มีความสอดคล้องกับ
              วัตถุประสงค์ของโครงการ)
            </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
            >(โปรดระบุ)</span
            >
          </div>
          <TextArea
              theme="3"
              :value="form.s2_p12_objective"
              @onChange="setFormField('s2_p12_objective', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            7. ระบุปัญหาหรือความต้องการของภาคเอกชน
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
            >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
              theme="3"
              :value="form.s2_p6_prv_org_issue_desc"
              @onChange="setFormField('s2_p6_prv_org_issue_desc', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            8. กิจการของภาคเอกชน ได้รับการแก้ไขปัญหาด้านใดจากการเข้าร่วมโครงการ
            <div class="theme-color-seven txt-normal" style="text-indent: 16px">
              อธิบายในหัวข้อที่ตรงกับกิจการของภาคเอกชนที่ได้รับการแก้ไขปัญหา
              (ตอบได้มากกว่า 1 ข้อ)
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">พัฒนาคุณภาพสินค้าให้ได้มาตรฐาน</div>
              <Wysiwyg
                theme="3"
                :value="form.s2_p5_prv_org_impr_product_quality"
                @onChange="
                  setFormField('s2_p5_prv_org_impr_product_quality', $event)
                "
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">การแก้ไขปัญหาของกระบวนการผลิต</div>
            <Wysiwyg
              theme="3"
              :value="form.s2_p5_prv_org_impr_process_issue"
              @onChange="
                setFormField('s2_p5_prv_org_impr_process_issue', $event)
              "
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              การปรับปรุงประสิทธิภาพกระบวนการผลิต
            </div>
            <Wysiwyg
              theme="3"
              :value="form.s2_p5_prv_org_impr_process_eff"
              @onChange="setFormField('s2_p5_prv_org_impr_process_eff', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">การพัฒนาผลิตภัณฑ์ใหม่</div>
            <Wysiwyg
              theme="3"
              :value="form.s2_p5_prv_org_impr_new_product"
              @onChange="setFormField('s2_p5_prv_org_impr_new_product', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            9. เทคโนโลยี นวัตกรรม
            เเละการพัฒนาด้านใดที่นำมาใช้ในการเเก้ไขปัญหาให้กับภาคเอกชน
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :value="form.s2_p7_inno_desc"
            @onChange="setFormField('s2_p7_inno_desc', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            10. ศักยภาพและความพร้อมในการดำเนินโครงการของภาคเอกชน
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดกรอกข้อมูลให้ครบทุกข้อ)</span
            >
          </div>
          <div>
            <div class="black--text mb-3">
              ศักยภาพความพร้อมในการทำงานวิจัยและพัฒนา
            </div>
            <ul class="pl-16">
              <li>
                <div>
                  <div class="black--text mb-3">
                    มีความรู้พื้นฐานด้านเทคโนโลยีที่
                    เกี่ยวข้องกับผลิตภัณฑ์และกระบวนการ
                  </div>
                  <Wysiwyg
                    theme="3"
                    :value="form.s2_p8_prv_org_project_readiness"
                    @onChange="
                      setFormField('s2_p8_prv_org_project_readiness', $event)
                    "
                  ></Wysiwyg>
                </div>
              </li>
              <li>
                <div>
                  <div class="black--text mb-3">
                    ความพร้อมด้านอุปกรณ์ เครื่องมือ ในการทำงานวิจัย
                  </div>
                  <Wysiwyg
                    theme="3"
                    :value="form.s2_p8_prv_org_rnd_readiness"
                    @onChange="
                      setFormField('s2_p8_prv_org_rnd_readiness', $event)
                    "
                  ></Wysiwyg>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-1">ความพร้อมด้านการเงิน</div>
          <Wysiwyg
            theme="3"
            :value="form.s2_p8_prv_org_financial_readiness"
            @onChange="
              setFormField('s2_p8_prv_org_financial_readiness', $event)
            "
          ></Wysiwyg>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-1">การบริหารจัดการองค์กรและบุคลากร</div>
          <Wysiwyg
            theme="3"
            :value="form.s2_p8_prv_org_mgmt_readiness"
            @onChange="setFormField('s2_p8_prv_org_mgmt_readiness', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            11. ศักยภาพและความพร้อมในการดำเนินโครงการของอุทยานวิทยาศาสตร์ภูมิภาค
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดกรอกข้อมูลให้ครบทุกข้อ)</span
            >
          </div>
        </div>

        <div>
          <div class="black--text mb-1">
            ความพร้อมของบุคลากรและผู้เชี่ยวชาญ
            ประสบการณ์การทำงานร่วมกับภาคอุตสาหกรรม
          </div>
          <Wysiwyg
            theme="3"
            :value="form.s2_p9_personnel_expertise"
            @onChange="setFormField('s2_p9_personnel_expertise', $event)"
          ></Wysiwyg>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-1">
            ความพร้อมของห้องปฏิบัติการ
            เครื่องมืออุปกรณ์ทางวิทยาศาสตร์และสิ่งอำนวยความสะดวก
          </div>
          <Wysiwyg
            theme="3"
            :value="form.s2_p9_lab_eqt_readiness"
            @onChange="setFormField('s2_p9_lab_eqt_readiness', $event)"
          ></Wysiwyg>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-1">
            องค์ความรู้พื้นฐานที่จะช่วยสนับสนุนการแก้โจทย์จากภาคเอกชน
          </div>
          <Wysiwyg
            theme="3"
            :value="form.s2_p9_knowledge_readiness"
            @onChange="setFormField('s2_p9_knowledge_readiness', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            12. ขั้นตอนและขอบเขตการดำเนินโครงการ
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :value="form.s2_p10_project_scope_detail"
            @onChange="setFormField('s2_p10_project_scope_detail', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">5. ที่มาและความสำคัญ</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :value="form.s2_source"
            @onChange="setFormField('s2_source', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">6. ประเภทอุตสาหกรรม</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :value="form.s2_industry_type"
            @onChange="setFormField('s2_industry_type', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head"
              >7. รูปแบบการเข้าร่วมโครงการเพื่อรับบริการ</span
            >
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <AutoBox
            theme="3"
            :items="apply_type_list"
            multiple
            chips
            deletable-chips
            :value="form.s2_apply_type"
            @onChange="setFormField('s2_apply_type', $event)"
          ></AutoBox>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">8. ผลการดำเนินงาน</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :value="form.s2_overall_result"
            @onChange="setFormField('s2_overall_result', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head"
              >9. สรุปรายละเอียดแผนการดำเนินงาน / กิจกรรมหลัก</span
            >
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :value="form.s2_summary_operation_detail"
            @onChange="setFormField('s2_summary_operation_detail', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head"
              >10.
              ความสนใจในการใช้บริการอื่นๆของอุทยานวิทยาศาสตร์ภูมิภาคในอนาคต</span
            >
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <AutoBox
            theme="3"
            :items="interest_list"
            multiple
            chips
            deletable-chips
            :value="form.s2_interest"
            @onChange="setFormField('s2_interest', $event)"
          ></AutoBox>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../../components/input/TextField";
import TextArea from "../../../../components/input/TextArea";
import SwitchInset from "../../../../components/input/SwitchInset";
import Button from "@/components/input/Button"
import AutoBox from "../../../../components/input/AutoBox";
import {eventBus, formatNumber, validateEmail} from "../../../../plugins/global-funcs";
import { mapState } from "vuex";
import Wysiwyg from "../../../../components/input/Wysiwyg.vue";

export default {
  name: "CFormProject_IRTC",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    Wysiwyg,
    Button
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      form: {},
      private_sum: null,
      inkind_sum: null,
      incash_sum: null,
      scipark_sum: null,
      inkind_percent: null,
      incash_percent: null,
      scipark_percent: null,
      industryBusinesses: [
        "กลุ่มอุตสาหกรรมมุ่งเน้น (Flagship project)",
        "อุทยานวิทยาศาสตร์ภาคเหนือ (NSP) ข้าว",
        "อุทยานวิทยาศาสตร์ภาคตะวันออกเฉียงเหนือ (NESP) ไก่",
        "อุทยานวิทยาศาสตร์ภาคใต้ (STSP) ยางพารา",
        "กลุ่มอุตสาหกรรมด้านเทคโนโลยีสารสนเทศ เช่น IT software IOS Android, และ Digital content ต่าง ๆ (เชื่อมโยงถึงอุตสาหกรรมการผลิตการท่องเที่ยวและอุตสาหกรรมการออกแบบและสร้างสรรค์)",
        "กลุ่มอุตสาหกรรมด้านการแพทย์ และเทคโนโลยีชีวภาพ",
        "กลุ่มอุตสาหกรรมอาหาร",
        "กลุ่มอุตสาหกรรมด้านเทคโนโลยีพลังงานทดแทน สิ่งแวดล้อม และวัสดุด้านพลังงาน",
        "กลุ่มอุตสาหกรรมอื่นๆ ที่มีศักยภาพในการเติบโต เช่น อุตสาหกรรมเวชภัณฑ์(เครื่องสําอาง) อุตสาหกรรมโลจิสติกส์ และห่วงโซ่อุปทาน",
      ],
      apply_type_list: [
        "การแก้ไขปัญหาของกระบวนการผลิต",
        "ปรับปรุงประสิทธิภาพกระบวนการผลิต",
        "พัฒนาคุณภาพสินค้าให้ได้มาตรฐานสากล",
        "พัฒนาผลิตภัณฑ์ใหม่",
      ],
      interest_list: [
        "Service Platform",
        "Business Incubation",
        "IRTC",
        "Co-Research",
      ],
      filteredDistricts: [],
      filteredSubdistricts: [],
      teams: [],
      emailRules: [
        (v) => !!v || "",
        (v) => validateEmail(v) || "อีเมลไม่ถูกต้อง",
      ],
    };
  },
  watch: {
    formData: {
      handler(newValue) {
        if (!newValue) {
          this.form = this.masterData.form_c?.project_section || {};
        } else {
          this.form = newValue;
        }

        if (this.form.s2_p3_addr_pid) {
          const province_id = parseInt(
            this.masterData.provinces.find(
              (province) => province.name === this.form.s2_p3_addr_pid
            ).province_id
          );
          this.filteredDistricts = this.masterData.districts.filter(
            (district) => district.province_id === province_id
          );
        }

        if (this.form.s2_p3_addr_did) {
              const province_id = parseInt(
            this.masterData.provinces.find(
              (province) => province.name === this.form.s2_p3_addr_pid
            ).province_id
          );
          const district_id = parseInt(
            this.masterData.districts.find(
              (district) => district.name === this.form.s2_p3_addr_did && district.province_id === province_id
            ).district_id
          );
          this.filteredSubdistricts = this.masterData.subdistricts.filter(
            (subdistrict) => subdistrict.district_id === district_id && subdistrict.province_id === province_id
          );
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      ProjectForm: (state) => state.CForm.ProjectForm,
      GeneralForm: (state) => state.CForm.GeneralForm,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created() {
    if (this.isSameId && !this.masterData.form_c) {
      this.form = { ...this.ProjectForm, project_teams: undefined }
      this.teams = this.ProjectForm.project_teams || [];
    }
    if (this.masterData.form_c) {
      this.form = this.masterData.form_c.project_section;
      this.teams = this.masterData.form_c.project_teams || [];
      this.calculateBudgetProportion();
    }
    eventBus.$on("cFormProject", () => {
      eventBus.$emit("cFormProjectSend", { ...this.form, project_teams: this.teams });
    });

  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;

          if (field === "s2_p3_addr_pid") {
      // หา province_id จาก name
      const province_id = parseInt(
        this.masterData.provinces.find(province => province.name === val)?.province_id
      );
      this.filteredDistricts = this.masterData.districts.filter(
        district => district.province_id === province_id
      );

      // reset ค่า district / subdistrict
      this.form.s2_p3_addr_did = "";
      this.form.s2_p3_addr_sdid = "";
      this.filteredSubdistricts = [];
    }

    if (field === "s2_p3_addr_did") {
      // หา district_id จาก name
           const province_id = parseInt(
            this.masterData.provinces.find(
              (province) => province.name === this.form.s2_p3_addr_pid
            ).province_id
          );
          const district_id = parseInt(
            this.masterData.districts.find(
              (district) => district.name === this.form.s2_p3_addr_did && district.province_id === province_id
            ).district_id
          );
          this.filteredSubdistricts = this.masterData.subdistricts.filter(
            (subdistrict) => subdistrict.district_id === district_id && subdistrict.province_id === province_id
          );

      // reset ค่า subdistrict
      this.form.s2_p3_addr_sdid = "";
    }

      this.$forceUpdate();
    },
    setTeamField(field, i, val) {
      this.teams[i][field] = val;
      this.$forceUpdate();
    },
    calculateBudgetProportion() {
      let budgetList =
        this.masterData.form_c?.project_section_plan?.project_section_budget;

      if (budgetList !== undefined && budgetList.length > 0) {
        let all_sum = budgetList
          .map((x) => x.budget_sum)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_sum = budgetList
          .map((x) => x.budget_in_kind)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.incash_sum = budgetList
          .map((x) => x.budget_in_cash)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.private_sum = this.inkind_sum + this.incash_sum;
        this.scipark_sum = budgetList
          .map((x) => x.budget_sci_park)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_percent = ((this.inkind_sum * 100) / all_sum).toFixed(2);
        this.incash_percent = ((this.incash_sum * 100) / all_sum).toFixed(2);
        this.scipark_percent = ((this.scipark_sum * 100) / all_sum).toFixed(2);
      }
    },
    addMoreTeam () {
      this.teams.push({})
    },
    delTeam (index) {
      this.teams.splice(index, 1)
    }
  },
};
</script>

<style scoped></style>
